<template>
  <b-card>

    <b-row>
      <b-col class="float-right" cols="12" md="12">
        <b-button class="m-1" variant="primarySpore" @click="back()">Regresar</b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col class="float-right" cols="12" md="12">
        <feather-icon v-b-tooltip.hover.left title="Editar" icon="EditIcon" @click="edit = true" class="float-right cursor-pointer" svgClasses="hover:text-primary" v-if="!edit" />
      </b-col>
    </b-row>

    <div v-if="!edit">
      <b-row class="m-2">
        <b-col cols="12" md="4">
          <h4>Número: </h4> {{response.number}}
        </b-col>
        <b-col cols="12" md="4">
          <h4>Nombre: </h4> {{response.name}}
        </b-col>
        <b-col cols="12" md="4">
          <h4>Encargado: </h4> {{response.manager}}
        </b-col>
      </b-row>
    </div>

    <b-form class="m-2" v-if="show">
      <b-row v-if="edit === true">
        <b-col cols="12" md="3">
          <b-form-group label="Número" label-for="number">
            <b-form-input id="number" v-model="response.number" trim></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Nombre" label-for="name">
            <b-form-input id="name" v-model="response.name" trim></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Encargado" label-for="manager">
            <b-form-input id="manager" v-model="response.manager" trim></b-form-input>
            </b-form-group>
        </b-col>
      </b-row>
    </b-form>

    <!-- Action Buttons -->
    <div v-if="edit">
      <b-button type="submit" class="m-1" variant="primarySpore" @click="save()">Guardar</b-button>
      <b-button type="reset" class="m-1" variant="outline-danger" @click="cancel()">Cancelar</b-button>
    </div>

  </b-card>

</template>

<script>
/* eslint-disable global-require */

import {
  BButton, BCard, BForm, BCol, BRow, BFormGroup, BFormInput, VBTooltip
} from 'bootstrap-vue'

import request from '@/libs/request/index'

export default {
  components: {
    BButton, BCard, BForm, BCol, BRow, BFormGroup, BFormInput
  },
  directives: {
    'b-tooltip': VBTooltip
  },
  data () {
    return {
      edit: false,
      uuid: this.$route.params.uuid,
      response: {},
      show: true
    }
  },
  methods: {
    cancel () {
      this.edit = false
      this.getDetail()
    },
    back () {
      this.$router.push('/teams')
    },
    async getDetail () {
      const params = {
        url: `/teams/${this.uuid}`,
        method: 'GET'
      }
      await request(params).then(data => {
        if (data.data.code === 200) {
          this.response = data.data.data[0]
        }
      })
    },
    async save () {
      const params = {
        url: `/teams/${this.uuid}`,
        method: 'PUT',
        params: {
          number: this.response.number,
          name: this.response.name,
          manager: this.response.manager
        }
      }
      await request(params).then(data => {
        this.edit = false
        this.getDetail()
      })
    }
  },
  created () {
    this.getDetail()
  }
}
</script>
